<template>
  <div class="app-years-track" ref="sliderWrap">
    <div class="app-years-track__button-prev"
         :class="[progress <= 0 ? 'disabled' : '']" @click="goToPrev"></div>
    <div class="swiper-container" ref="slider">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, idx) in years" :key="idx"
             @click="onChoice(item.id, idx)">
          <div class="app-years-track__item"
               :class="[activeIndex === idx ? 'is-active': '']">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="app-years-track__button-next"
         :class="[progress === 1 ? 'disabled' : '']" @click="goToNext"></div>
  </div>
</template>

<script>
/* eslint-disable */

import {Swiper } from "swiper";

export default {
  name: 'AppYearsTrack',
  components: {},
  props: ['data'],
  data() {
    return {
      activeIndex: 0,
      progress: 0,
    };
  },
  computed: {
    years() {
      return this.data.map((item) =>{return {name: item.code, id: item.id}});
    },
    favorites() {
      if (this.data.favorites) {
        return true;
      }
      return this.data.favorites === false;
    },
  },
  methods: {
    onChoice(item, idx) {
      if (this.activeIndex !== idx) {
        this.$emit('choiceYear', item);
        this.activeIndex = idx
      }
    },

    initSwiper () {
      const that = this;
      this.$nextTick(() => {
        const swiperEl = this.$refs.slider;
        const prev = this.$refs.prev;
        const next = this.$refs.next;

        this.sliderInstance = new Swiper(swiperEl, {
          speed: 300,
          a11y: false,
          loop: false,
          slidesPerView: 2,
          spaceBetween: 0,
          breakpoints: {
            640: {
              slidesPerView: 4,
            },
            1025: {
              slidesPerView: 8,
            },
          },
          on: {
            init() {
              if (window.innerWidth > 1024) {
                if (this.slides.length <= 8) {
                  that.$refs.sliderWrap.classList.add('nav-hidden')
                }
              }
            },
            resize() {
              if (window.innerWidth > 1024) {
                if (this.slides.length <= 8) {
                  that.$refs.sliderWrap.classList.add('nav-hidden')
                }
              } else {
                that.$refs.sliderWrap.classList.remove('nav-hidden')
              }
            },
            slideChange() {
              that.progress = this.progress;
            }
          }
        });
      });
    },
    goToPrev() {
      this.sliderInstance.slidePrev();
    },
    goToNext() {
      this.sliderInstance.slideNext();
    },
  },
  mounted() {
    this.initSwiper();
  }
};
</script>

<style lang="scss">
  @import "app-years-track";
</style>
